"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = void 0;
var detailsActions = require("@caddigital/sok-reducers/lib/actions/activity/details");
var listActions = require("@caddigital/sok-reducers/lib/actions/activity/list");
var bidListActions = require("@caddigital/sok-reducers/lib/actions/bid/list");
var projectActions = require("@caddigital/sok-reducers/lib/actions/activity/projects");
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (opts) {
        return dispatch(listActions.fetchActivitiesRequest(opts));
    },
    fetchTypes: function (briefcase) {
        return dispatch(listActions.fetchActivityTypesRequest(briefcase && briefcase.uuid));
    },
    searchProject: function (searchString) {
        return dispatch(projectActions.fetchRequest(searchString));
    },
    clear: function () { return (dispatch(listActions.clear()), dispatch(projectActions.clear())); },
    fetchBids: function (briefcase) {
        return dispatch(bidListActions.fetchRequest(briefcase));
    },
    openActivityDetails: function (activity) { return (dispatch(detailsActions.toggleModal(true)),
        dispatch(detailsActions.fetchRequest(activity))); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
